class bkListCtrl {
    /**
     * 1
     * accountId (integer, optional): 主键ID ,
        bank (string, optional): 开户银行 ,
        bankAccount (string, optional): 开户银行账号 ,
        isBasic (integer, optional): 是否基本账号,0(否);1(是) ,
        remark (string, optional): 备注描述 ,
        saleId (integer, optional): 销方ID
     */
    constructor($rootScope, $scope, httpRequest, sweetalert, $state) {
        // 是否显示下拉选项控制
        $scope.isShowOption = false
        // 获取 商品类型树
        $scope.typeTree = []
        const buildTree = function (list) {
            function recursion(data, pid) {
                const result = []
                let temp
                for (const i in data) {
                    if (data[i].parentTypeId == pid) {
                        result.push(data[i])
                        temp = recursion(data, data[i].typeId)
                        if (temp.length > 0) {
                            data[i].children = temp
                        }
                    }
                }
                return result
            }
            return recursion(list, -1)
        }
        const init = function () {
            httpRequest.get_getLoginUserGoodsTypeList($state.params.type).then((res) => {
                $scope.typeTree = buildTree(res.data.value)
            })
        }
        // 汉字英文真实长度
        const getStringLen = function (str) {
            // /<summary>获得字符串实际长度，中文2，英文1</summary>
            // /<param name="str">要获得长度的字符串</param>
            let realLength = 0
            const len = str.length
            let charCode = -1
            for (let i = 0; i < len; i++) {
                charCode = str.charCodeAt(i)
                if (charCode >= 0 && charCode <= 128) realLength += 1
                else realLength += 2
            }
            return realLength
        }

        init()
        $scope.erroMsg = null
        $scope.inputValidate = function (val) {
            if (typeof val !== 'string') {
                return $scope.erroMsg = '不能为空'
            }
            const len = getStringLen(val)
            if (len < 4) {
                return $scope.erroMsg = '不能少于4个字符，一个汉字算2个字符'
            } if (len > 40) {
                return $scope.erroMsg = '不能大于40个字符，一个汉字算2个字符'
            }
            $scope.erroMsg = null
        }
        $scope.typeNameChange = function (val) {
            $scope.inputValidate(val)
        }

        // 删除节点
        $scope.nodeRemove = function (node) {
            if (node.children && node.children.length > 0) {
                sweetalert.confirm('提示', '存在下级分类,请先移除下级分类!')
            } else {
                sweetalert.confirm('删除提醒', '确认是否删除该分类').then(() => {
                    httpRequest.post_delGoodsType(node.typeId, '删除成功').then(() => {
                        $rootScope.$broadcast('goodsTypeChange')
                        init()
                    })
                })
            }
        }
        //
        $scope.cancel = function (node) {
            // 新增状态下取消删除节点
            if (node.action === 'add') {
                $scope.isAdd = true
                init()
            }
            node.action = null
            $scope.erroMsg = null
        }
        // 编辑
        $scope.nodeEdit = function (node) {
            if ($scope.inputValidate(node.typeName)) return
            // 后台请求新增
            node.goodCategory = $state.params.type
            httpRequest.post_modGoodsType(node, '编辑成功').finally(() => {
                $rootScope.$broadcast('goodsTypeChange')
                $scope.isAdd = true
                init()
            })
        }
        // 新增
        $scope.nodeAdd = function (node) {
            // 为空提示错误
            if ($scope.inputValidate(node.typeName)) return
            // 后台请求新增
            node.goodCategory = $state.params.type
            httpRequest.post_addGoodsType(node, '新增成功').finally((res) => {
                $rootScope.$broadcast('goodsTypeChange')
                $scope.isAdd = true
                init()
            })
            node.action = null
        }
        // 点击创建子节点菜单
        // 如果新增 节点 没有 typeid 更新时候需要则 可能导致错误
        $scope.newSubNode = function (node) {
            $scope.erroMsg = null
            const nodeData = node
            if (!nodeData.children) nodeData.children = []
            nodeData.children.push({
                parentTypeId: nodeData.typeId,
                typeName: '',
                action: 'add',
                level: node.level + 1,
            })
        }
        $scope.isAdd = true
        // 新增顶层 类别
        $scope.addTopType = function () {
            if ($scope.isAdd) {
                $scope.typeTree.push({
                    parentTypeId: -1,
                    typeName: '',
                    action: 'add',
                    className: 'exception',
                })
                $scope.isAdd = false
            }
        }

        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        $scope.toggle = function toggle(node) {
            node.collapsed = !node.collapsed
        }
    }
}
bkListCtrl.$inject = ['$rootScope', '$scope', 'httpRequest', 'sweetalert', '$state']
export default bkListCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/gdTypeCtrl.js